module.exports = __webpack_public_path__ + "img/focaccia_closeup.beab78ff.jpg";